<template>
  <div id="app">
    <v-header v-if="header_show"></v-header>
    <!-- <v-menu v-if="nav_show"></v-menu> -->
    <v-nav v-if="nav_show"></v-nav>
    <router-view
      v-on:public_header="public_header"
      v-on:public_nav="public_nav"
      v-on:public_footer="public_footer"
    ></router-view>
    <v-footer v-if="footer_show"></v-footer>
  </div>
</template>

<script>
import header from "./components/header.vue";
import nav from "./components/nav.vue";
import footer from "./components/page_footer.vue";
export default {
  name: "App",
  data() {
    return {
      header_show: true,
      nav_show: true,
      footer_show: true
      /** 默认main为主页内容显示 */
      // view: main
    };
  },
  methods: {
    /** 是否显示头部 */
    public_header(bool) {
      this.header_show = bool;
    },
    /** 是否显示导航栏 */
    public_nav(bool) {
      this.nav_show = bool;
    },
    /** 是否显示尾部 */
    public_footer(bool) {
      this.footer_show = bool;
    }
  },
  components: {
    header,
    nav,
    footer
  },
  watch: {
    $route() {}
  },
  computed: {}
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
ul li,
ol li {
  list-style: none;
}
a {
  color: #333;
  text-decoration: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
/*统一模块标题样式*/
.unified-module-title {
  padding: 30px 0 15px 0px;
  text-align: center;
  letter-spacing: 2px;
  font-size: 30px;
  display: inline-block;
  font-family: "Microsoft YaHei", 微软雅黑, MicrosoftJhengHei, 华文细黑, STHeiti,
    MingLiu;
}
.banner {
  background: rgb(0, 152, 239);
  width: 100%;
  height: 250px;
  color: #fff;
  padding-top: 65px;
  box-sizing: border-box;
  text-align: center;
}
.content-title {
  padding-top: 66px;
  font-size: 28px;
  color: rgb(51, 51, 51);
  text-align: center;
}
/* 面包屑盒子 */
.breadcrumb-nav {
  /* width: 1200px; */
  width: 1000px;
  height: 52px;
  margin: 0 auto;
  line-height: 52px;
  /* border-bottom: 1px solid #ebebeb; */
}
</style>
<style src="./assets/font-awesome/css/font-awesome.min.css"></style>



// WEBPACK FOOTER //
// src/App.vue